import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-inicio2',
  templateUrl: './inicio2.page.html',
  styleUrls: ['./inicio2.page.scss'],
})
export class Inicio2Page implements OnInit {

  constructor() { }

  public ngOnInit() {

    // ------------------------------
    // -------- JQuery --------------
    // ------------------------------
    $('#preloader').animate({
      opacity: '0'
    }, 600, () => {
      setTimeout(() => {
          $('#preloader').css('visibility', 'hidden').fadeOut();
      }, 300);
    });

    $('#mainContent').scroll(() => {

      const scroll = $('#mainContent').scrollTop();
      const box = $('.header-text').height();
      const header = $('header').height();

      if (scroll >= box - header) {
        $('header').addClass('background-header');
      } else {
        $('header').removeClass('background-header');
      }
    });

    if ($('.owl-clients').length) {
      // @ts-ignore
      $('.owl-clients').owlCarousel({
          loop: true,
          nav: false,
          dots: true,
          items: 1,
          margin: 30,
          autoplay: false,
          smartSpeed: 700,
          autoplayTimeout: 6000,
          responsive: {
              0: {
                  items: 1,
                  margin: 0
              },
              460: {
                  items: 1,
                  margin: 0
              },
              576: {
                  items: 3,
                  margin: 20
              },
              992: {
                  items: 5,
                  margin: 30
              }
          }
      });
    }

    if ($('.owl-testimonials').length) {
        // @ts-ignore
        $('.owl-testimonials').owlCarousel({
            loop: true,
            nav: false,
            dots: true,
            items: 1,
            margin: 30,
            autoplay: false,
            smartSpeed: 700,
            autoplayTimeout: 6000,
            responsive: {
                0: {
                    items: 1,
                    margin: 0
                },
                460: {
                    items: 1,
                    margin: 0
                },
                576: {
                    items: 2,
                    margin: 20
                },
                992: {
                    items: 2,
                    margin: 30
                }
            }
        });
    }

    if ($('.owl-banner').length) {
        // @ts-ignore
        $('.owl-banner').owlCarousel({
            loop: true,
            nav: true,
            dots: true,
            items: 0,
            margin: 0,
            autoplay: true,
            smartSpeed: 700,
            autoplayTimeout: 5000,
            animateOut: 'fadeOut',
            responsive: {
                0: {
                    items: 1,
                    margin: 0
                },
                460: {
                    items: 1,
                    margin: 0
                },
                576: {
                    items: 1,
                    margin: 20
                },
                992: {
                    items: 1,
                    margin: 30
                }
            }
        });
    }
  }

}
